<template lang="pug">
v-card(
  color="secondary"
  dark
  flat
).sdo-radius.pa-4.mb-6
  v-list.transparent
    v-list-item(v-if="group.short_name")
      v-list-item-content
        .text-caption Группа:
        v-list-item-title {{ group.short_name }}
        v-list-item-subtitle

    v-list-item(
      v-if="telegram.enrollment"
      target="_blank"
      :href="$user.data.telegram && telegram.enrollment.invite_link"
      @click="!$user.data.telegram && $user.openSignUpTelegram()"
    )
        v-list-item-icon.mr-0: v-icon.mr-4(size="38") $telegram
        v-list-item-title Курсовой чат

    v-list-item(
      v-if="telegram.group"
      target="_blank"
      :href="$user.data.telegram && telegram.group.invite_link"
      @click="!$user.data.telegram && $user.openSignUpTelegram()"
    )
      v-list-item-icon.mr-0: v-icon.mr-4(size="38") $telegram
      v-list-item-title Чат группы
    v-list-item(
      link
      :disabled="!course.hasPermissions.consultations"
      @click="course.openChatAsStudent()"
    )
      v-list-item-icon.mr-0
        v-badge(
          :value="course.hasConsultationMessages || !course.hasPermissions.consultations"
          :color="course.hasPermissions.consultations ? 'error' : 'transparent'"
          :dot="course.hasPermissions.consultations"
          :offset-x="course.hasPermissions.consultations ? 8 : 16"
          :offset-y="course.hasPermissions.consultations ? 8 : 10"
          left
        )
          template(#badge)
            v-avatar(size="24" color="error")
              v-icon(size="20" color="white") mdi-lock-outline
          v-icon.mr-4(
            size="38"
          ) mdi-forum
      v-list-item-content Консультация по организационным вопросам
</template>
<script>
export default {
  props: {
    group: { type: Object, default: () => {} },
    course: { type: Object, default: () => {} },
  },
  data() {
    return {
      telegram: {
        enrollment: null,
        group: null,
      },
    };
  },
  async created() {
    await this.fetchTelegramChats();
  },
  methods: {
    async fetchTelegramChats() {
      const record = this.course.priority_user_prior_record;
      if (record) {
        let resp = await this.$api.enrollments.getEnrollment(
          record.id, { params: { expand: 'telegram' } },
        );
        const telegram = resp.data?.data?.telegram?.find((i) => i.type === 1);
        this.telegram.enrollment = telegram;

        if (record.user_record.status && record.user_record.group.id) {
          resp = await this.$api.groups.getGroup(
            record.user_record.group.id, { params: { expand: 'telegram' } },
          );
          const telegramF = resp.data.data?.telegram?.find((i) => i.type === 1);
          this.telegram.group = telegramF;
        }
      }
    },
  },
};
</script>
